import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const selectedEmploymentStatusFilterSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.selectedEmploymentStatusFilter,
);

export default selectedEmploymentStatusFilterSelector;
